
const ExpensesStarter = ({ setCreateExpense }) => {
    return (
        <div className="_2fnj">
            <div className="clarions-pods">
                <h3>It's time to take control of your expenses!</h3>
                <span className="frumpy-gel">Establish and oversee expenses integral to your organization's operational expenditures.</span>
                <button onClick={() => setCreateExpense(true)}>Record Expense</button>
            </div>
        </div>
    )
}

export default ExpensesStarter

